module.exports = __webpack_public_path__ + "img/titleIcon2.d6963fd4.png";